import { defineAsyncComponent } from "vue";

const componentMappings = {
  // pages
  "d2c-lm:pages/basic": defineAsyncComponent(() => import("../../templates/pages/BasicPage.vue")),
  "d2c-lm:pages/error": defineAsyncComponent(() => import("../../templates/pages/ErrorPage.vue")),
  "d2c-lm:pages/article": defineAsyncComponent(() => import("~/templates/pages/ArticlePage.vue")),
  "d2c-lm:pages/faq": defineAsyncComponent(() => import("~/templates/pages/FAQPage.vue")),
  // shop pages
  "d2c-lm:pages/shop/cart": defineAsyncComponent(
    () => import("../../templates/pages/CartPage.vue"),
  ),
  "d2c-lm:pages/shop/checkout": defineAsyncComponent(
    () => import("~/templates/pages/checkout/index.vue"),
  ),
  "d2c-lm:pages/shop/checkout.success": defineAsyncComponent(
    () => import("~/templates/pages/checkout/CheckoutSuccessPage.vue"),
  ),
  "d2c-lm:pages/shop/product": defineAsyncComponent(
    () => import("~/templates/pages/ProductDetailPage.vue"),
  ),
  "d2c-lm:pages/shop/product-exchange-box": defineAsyncComponent(
    () => import("~/templates/pages/ProductDetailPage.vue"),
  ),
  "d2c-lm:pages/shop/product-registration": defineAsyncComponent(
    () => import("~/templates/pages/shop/ProductRegistrationPage.vue"),
  ),
  "d2c-lm:pages/shop/product-subscription": defineAsyncComponent(
    () => import("~/templates/pages/ProductDetailPage.vue"),
  ),
  "d2c-lm:pages/shop/order-lookup": defineAsyncComponent(
    () => import("~/templates/pages/shop/OrderLookupPage.vue"),
  ),
  "d2c-lm:pages/shop/order-payment": defineAsyncComponent(
    () => import("~/templates/pages/shop/OrderPaymentPage.vue"),
  ),
  // account
  "d2c-lm:pages/account/register": defineAsyncComponent(
    () => import("~/templates/pages/account/AccountRegister.vue"),
  ),
  "d2c-lm:pages/account/overview": defineAsyncComponent(
    () => import("~/templates/pages/account/AccountOverview.vue"),
  ),
  "d2c-lm:pages/account/order": defineAsyncComponent(
    () => import("~/templates/pages/account/AccountOrderHistory.vue"),
  ),
  "d2c-lm:pages/account/order-details": defineAsyncComponent(
    () => import("~/templates/pages/account/AccountOrderDetails.vue"),
  ),
  "d2c-lm:pages/account/order-return": defineAsyncComponent(
    () => import("~/templates/pages/account/AccountOrderReturn.vue"),
  ),
  "d2c-lm:pages/account/order-warranty": defineAsyncComponent(
    () => import("~/templates/pages/account/AccountOrderWarranty.vue"),
  ),
  "d2c-lm:pages/account/address": defineAsyncComponent(
    () => import("~/templates/pages/account/AccountAddressBook.vue"),
  ),
  "d2c-lm:pages/account/profile": defineAsyncComponent(
    () => import("~/templates/pages/account/AccountProfile.vue"),
  ),
  "d2c-lm:pages/account/subscriptions": defineAsyncComponent(
    () => import("~/templates/pages/account/AccountOrderSubscriptions.vue"),
  ),
  "d2c-lm:pages/account/products": defineAsyncComponent(
    () => import("~/templates/pages/account/AccountProducts.vue"),
  ),
  // middleware
  "d2c-lm:pages/middleware/newsletter-doi": defineAsyncComponent(
    () => import("~/templates/pages/middleware/NewsletterDoiPage.vue"),
  ),
  "d2c-lm:pages/middleware/newsletter-unsubscribe": defineAsyncComponent(
    () => import("~/templates/pages/middleware/NewsletterUnsubscribe.vue"),
  ),
  // middleware
  "d2c-lm:pages/migration/yource-migration-page": defineAsyncComponent(
    () => import("~/templates/pages/migration/YourceMigrationPage.vue"),
  ),
  "d2c-lm:pages/migration/yource-migration-success-page": defineAsyncComponent(
    () => import("~/templates/pages/migration/YourceMigrationSuccessPage.vue"),
  ),
  // author only
  "d2c-lm:pages/author/common-labels-overview": defineAsyncComponent(
    () => import("~/templates/pages/author/CommonLabelsOverview.vue"),
  ),
  // components
  "d2c-lm:components/headline": defineAsyncComponent(
    () => import("../../templates/components/cms/SingleHeadlineComponent.vue"),
  ),
  "d2c-lm:components/image": defineAsyncComponent(
    () => import("../../templates/components/cms/ImageComponent.vue"),
  ),
  "d2c-lm:components/image-text": defineAsyncComponent(
    () => import("../../templates/components/cms/ImageTextComponent.vue"),
  ),
  "d2c-lm:components/multiple-image-text": defineAsyncComponent(
    () => import("~/templates/components/cms/MultipleImageTextComponent.vue"),
  ),
  "d2c-lm:components/multiple-image-text-component": defineAsyncComponent(
    () => import("~/templates/components/cms/MultipleImageTextAreaComponent.vue"),
  ),
  "d2c-lm:components/code": defineAsyncComponent(
    () => import("../../templates/components/cms/CodeComponent.vue"),
  ),
  "d2c-lm:components/iframe": defineAsyncComponent(
    () => import("../../templates/components/cms/IFrameComponent.vue"),
  ),
  "d2c-lm:components/section": defineAsyncComponent(
    () => import("../../templates/components/cms/SectionComponent.vue"),
  ),
  "d2c-lm:components/editorial-story": defineAsyncComponent(
    () => import("../../templates/components/cms/EditorialStoryComponent.vue"),
  ),
  "d2c-lm:components/editorial-story-slide": defineAsyncComponent(
    () => import("../../templates/components/cms/EditorialStorySlideComponent.vue"),
  ),
  "d2c-lm:components/editorial-story-headline": defineAsyncComponent(
    () => import("../../templates/components/cms/EditorialStoryHeadlineComponent.vue"),
  ),
  "d2c-lm:components/editorial-story-image": defineAsyncComponent(
    () => import("~/templates/components/cms/EditorialStoryImageComponent.vue"),
  ),
  "d2c-lm:components/editorial-story-text": defineAsyncComponent(
    () => import("~/templates/components/cms/EditorialStoryTextComponent.vue"),
  ),
  "d2c-lm:components/image-teaser": defineAsyncComponent(
    () => import("../../templates/components/cms/ImageTeaserComponent.vue"),
  ),
  "d2c-lm:components/image-teaser-tile": defineAsyncComponent(
    () => import("../../templates/components/cms/ImageTeaserTileComponent.vue"),
  ),
  "d2c-lm:components/story-teaser": defineAsyncComponent(
    () => import("../../templates/components/cms/StoryTeaserComponent.vue"),
  ),
  "d2c-lm:components/category-slider": defineAsyncComponent(
    () => import("../../templates/components/cms/CategorySliderComponent.vue"),
  ),
  "d2c-lm:components/story-slider": defineAsyncComponent(
    () => import("../../templates/components/cms/StorySliderComponent.vue"),
  ),
  "d2c-lm:components/category-tile": defineAsyncComponent(
    () => import("../../templates/components/cms/CategoryTileComponent.vue"),
  ),
  "d2c-lm:components/call-to-action": defineAsyncComponent(
    () => import("../../templates/components/cms/CallToActionComponent.vue"),
  ),
  "d2c-lm:components/rich-text": defineAsyncComponent(
    () => import("../../templates/components/cms/RichTextComponent.vue"),
  ),
  "d2c-lm:components/stage-carousel": defineAsyncComponent(
    () => import("../../templates/components/cms/StageCarouselComponent.vue"),
  ),
  "d2c-lm:components/stage-content": defineAsyncComponent(
    () => import("~/templates/components/cms/StageContentComponent.vue"),
  ),
  "d2c-lm:components/stage-story": defineAsyncComponent(
    () => import("~/templates/components/cms/StageStoryComponent.vue"),
  ),
  "d2c-lm:components/carousel-slide": defineAsyncComponent(
    () => import("../../templates/components/cms/StageCarouselSlideComponent.vue"),
  ),
  "d2c-lm:components/quote": defineAsyncComponent(
    () => import("../../templates/components/cms/QuoteComponent.vue"),
  ),
  "d2c-lm:components/download-list": defineAsyncComponent(
    () => import("../../templates/components/cms/DownloadListComponent.vue"),
  ),
  "d2c-lm:components/anchor": defineAsyncComponent(
    () => import("~/templates/components/cms/AnchorComponent.vue"),
  ),
  "d2c-lm:components/product-tiles": defineAsyncComponent(
    () => import("~/templates/components/cms/CMSProductTilesComponent.vue"),
  ),
  "d2c-lm:components/product-tile": defineAsyncComponent(
    () => import("~/templates/components/cms/ProductTile.vue"),
  ),
  "d2c-lm:components/promo-box": defineAsyncComponent(
    () => import("../../templates/components/cms/PromoBoxComponent.vue"),
  ),
  "d2c-lm:components/shop/product-listing": defineAsyncComponent(
    () => import("~/templates/components/cms/CMSProductListing.vue"),
  ),
  "d2c-lm:components/product-hero": defineAsyncComponent(
    () => import("~/templates/components/cms/CMSProductHero.vue"),
  ),
  "d2c-lm:components/newsletter-registration": defineAsyncComponent(
    () => import("~/templates/components/cms/NewsletterRegistrationComponent.vue"),
  ),
  "d2c-lm:components/benefits": defineAsyncComponent(
    () => import("~/templates/components/cms/BenefitsComponent.vue"),
  ),
  "d2c-lm:components/benefit-tile": defineAsyncComponent(
    () => import("~/templates/elements/BenefitTile.vue"),
  ),
  "d2c-lm:components/story-overview": defineAsyncComponent(
    () => import("~/templates/components/cms/StoryOverviewComponent.vue"),
  ),
  "d2c-lm:components/category-overview": defineAsyncComponent(
    () => import("~/templates/components/cms/CategoryOverviewComponent.vue"),
  ),
  "d2c-lm:components/category-overview-tile": defineAsyncComponent(
    () => import("~/templates/components/cms/CategoryOverviewTileComponent.vue"),
  ),
  "d2c-lm:components/scrollable-text-image-video": defineAsyncComponent(
    () => import("~/templates/components/cms/ScrollableTextImageVideo.vue"),
  ),
  "d2c-lm:components/scrollable-text-image-video-component": defineAsyncComponent(
    () => import("~/templates/components/cms/ScrollableTextImageVideoComponent.vue"),
  ),
  "d2c-lm:components/scrollable-text": defineAsyncComponent(
    () => import("~/templates/components/cms/ScrollableTextComponent.vue"),
  ),
  "d2c-lm:components/contact-form": defineAsyncComponent(
    () => import("~/templates/components/cms/ContactFormComponent.vue"),
  ),
  "d2c-lm:components/faq": defineAsyncComponent(() => import("~/templates/components/cms/Faq")),
  "d2c-lm:components/faq-with-directory": defineAsyncComponent(
    () => import("~/templates/components/cms/FAQWithDirectoryComponent.vue"),
  ),
  "d2c-lm:components/image-tiles": defineAsyncComponent(
    () => import("~/templates/components/cms/ImageTilesComponent.vue"),
  ),
  "d2c-lm:components/image-tile": defineAsyncComponent(
    () => import("~/templates/elements/ImageTile.vue"),
  ),
  "d2c-lm:components/contact-box": defineAsyncComponent(
    () => import("~/templates/components/cms/ContactBox.vue"),
  ),
  "d2c-lm:components/contact-box-tile": defineAsyncComponent(
    () => import("~/templates/components/ContactBoxTile.vue"),
  ),
  // Brand Landing Page

  "d2c-lm:components/product-usp-slider": defineAsyncComponent(
    () => import("../../templates/components/cms/ProductUSPSliderComponent.vue"),
  ),
  "d2c-lm:components/product-usp-card": defineAsyncComponent(
    () => import("../../templates/components/cms/ProductUSPCard.vue"),
  ),

  "d2c-lm:components/image-slider-tile": defineAsyncComponent(
    () => import("../../templates/components/cms/ImageComponent.vue"),
  ),
  "d2c-lm:components/image-slider": defineAsyncComponent(
    () => import("~/templates/components/cms/ImageSliderComponent.vue"),
  ),
  "d2c-lm:components/image-collage": defineAsyncComponent(
    () => import("~/templates/components/cms/ImageCollageComponent.vue"),
  ),
  "d2c-lm:components/video-stage": defineAsyncComponent(
    () => import("~/templates/components/cms/VideoStageComponent.vue"),
  ),
  "d2c-lm:components/app-teaser-grid": defineAsyncComponent(
    () => import("~/templates/components/cms/AppTeaserComponent.vue"),
  ),
  "d2c-lm:components/app-teaser-tile": defineAsyncComponent(
    () => import("~/templates/components/cms/AppTeaserTile.vue"),
  ),
  "d2c-lm:components/instagram-posts": defineAsyncComponent(
    () => import("~/templates/components/cms/InstagramPostsComponent.vue"),
  ),
  "d2c-lm:components/instagram-post-tile": defineAsyncComponent(
    () => import("~/templates/components/cms/InstagramPostTile.vue"),
  ),
  "d2c-lm:components/brand/product-scroller": defineAsyncComponent(
    () => import("~/templates/components/cms/brand/ProductScroller.vue"),
  ),

  // Auth
  "d2c-lm:components/auth/azure-ad-b2c-test": defineAsyncComponent(
    () => import("~/templates/components/auth/AzureAdB2CTestComponent.vue"),
  ),
};

export { componentMappings };
